import { AppNotificationInterface } from '../models/app-notification.interface';

export interface State {
  appNotifications: Array<AppNotificationInterface>;
}

export const initialState: State = {
  appNotifications: [],
};
